import { getChemicalOrder } from 'services/utils'

const CANCELED_STATUS = '1'

export const OrderPageType = {farm: 'FARM', pivot: 'PIVOT', order: 'ORDER'}

export const isChemicalCanceled = (order, chemical) => {
  if (!order?.resaleOrders) return false
  return getChemicalOrder(order.resaleOrders, chemical)?.status === CANCELED_STATUS
}

// Produto cancelado não exige data de aplicação (AB#18249)
export const isMissingApplicationDate = (order) =>
  Boolean(order?.chemicals?.some(chemical => chemical.applicationDate === null && !isChemicalCanceled(order, chemical)))
